<template lang="pug">
.log-wrapper
  .logbox
    .card
      .card-body.px-5.pt-3.pb-5.position-relative
        .text-center.mb-4
          //- img(src='assets/img/logo.png')
        form.needs-validation(@submit.stop.prevent="login" novalidate :disabled="!submission.success")
          .form-group.mb-3
            b-input-group
              b-input-group-text.text-primary(slot="prepend")
                i.fas.fa-user
              DebounceInput(
                required
                ref="username"
                autofocus
                type="text"
                v-model.trim.lazy="$v.username.$model"
                :placeholder='$t("ui.username")'
                :disabled="loading"
                :maxLength="$v.username.$params.maxLength.max"
                :dirty="$v.username.$dirty"
                :error="$v.username.$error"
                )
            ValidateResult(:value="$v.username" :name="$t('ui.username')")
          .form-group.mb-3
            b-input-group
              b-input-group-text.text-primary(slot="prepend")
                i.fas.fa-lock
              DebounceInput(
                required
                autocomplete="section-red current-password"
                :type=" (isPWShown) ? 'password' : 'text'"
                v-model.trim.lazy="$v.password.$model"
                :placeholder='$t("ui.password")'
                :disabled="loading"
                :maxLength="$v.password.$params.maxLength.max"
                :dirty="$v.password.$dirty"
                :error="$v.password.$error"
              )
              .input-group-append
                b-button(:pressed.sync="isPWShown" style="box-shadow:none;")
                  i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
            ValidateResult(:value="$v.password" :name="$t('ui.password')")
          .form-group.mb-3 
            b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
          .form-group.m-auto.w-70
            SubmitButton.btn-block.noboxshadow.br-8(icon="fa fa-sign-in-alt" :text="$t('message.login')" variant="primary" size="xs" :loading="loading" isModal=false)
        .text-light.logver
          small {{ app.title }} v{{ app.version }}
        .loglang
          nav.navbar.p-0.h-auto
            ul.navbar-nav.navbar-right
              li.dropdown
                a.nav-link.dropdown-toggle(href='#' data-toggle='dropdown' aria-expanded='false')
                  img.rounded-circle.mr-1(alt='image' :src="'/assets/img/flag/' + language + '.png?v=14'")
                  .d-sm-inline-block.d-none {{ $t("language.list." + language) }}
                .dropdown-menu
                  a.dropdown-item(href="javascript:void(0)" v-for="item in languageList" @click="setLanguage(item)")
                    img.rounded-circle.mr-1(alt='image' :src="'/assets/img/flag/' + item + '.png?v=13'")
                    | {{ $t("language.list." + item) }}


</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, alphaNum } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CryptoJS from "crypto-js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      languageList: ["en", "zh"],
      isPWShown: true,
      username: "",
      password: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    username: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50)
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(50)
    }
  },
  computed: {
    app() {
      return {
        title: config.appTitle,
        version: config.appVersion
      };
    },
    language() {
      return this.$store.getters.language;
    },
    domain() {
      return config.getDomain(window.location.hostname, false) == "localhost" ? "project360uat.com" : config.getDomain(window.location.hostname, false);
    },
    secretKey() {
      return config.secretKey
    },
  },
  created() {
  },
  mounted: function() {
    const url = this.$route.query.redirect;
    if (url) {
      this.redirect = url;
    }

    var appLang = config.appLang
    if(appLang != null) {
      var splitLang = appLang.split(',')
      for(var i = 0; i < splitLang.length; i++) {
        this.languageList.push(splitLang[i])
      }
    }
  },
  methods: {
    encryptData(data, key) {
      // Check the type of data and convert to string if necessary
      let dataString;
      if (typeof data === 'object') {
          // Convert object or array to JSON string
          dataString = JSON.stringify(data);
      } else if (typeof data === 'string') {
        // If data is already a string, use it as is
        dataString = data;
      } else {
        throw new Error("Unsupported data type for encryption. Must be an object, array, or string.");
      }

      const keyBytes = CryptoJS.enc.Base64.parse(key);
      const encrypted = CryptoJS.TripleDES.encrypt(dataString, keyBytes, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decryptData(encryptedData, key) {
      const keyBytes = CryptoJS.enc.Base64.parse(key);
      const decrypted = CryptoJS.TripleDES.decrypt(encryptedData, keyBytes, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      // Convert the decrypted data back to a UTF-8 string
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

      // Try to parse the string back into its original format (object, array, or string)
      try {
        return JSON.parse(decryptedString);
      } catch (e) {
        // If parsing fails, return the string as is
        return decryptedString;
      }
    },
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
      this.$refs.username.$el.focus();
    },
    setLanguage(lang) {
      this.$store.dispatch("layout/setLanguage", lang);
    },
    login: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let username = this.username;
        let password = this.password;
        let domain = this.domain;
        this.loading = true;
        this.$store
          .dispatch("user/login", { username, password, domain })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.status;
            if (this.submission.success == true) {
              this.globalSettingDetail2();
              this.$router.push(response.redirect);
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = this.$t("error." + response.status);
          });
      }
    },
    globalSettingDetail2: function() {
      let url = config.globalSettingDetail2Url();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        setting_key: "currency"
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.submission.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.submission.status = response.data.statusdesc;
              if (this.submission.success == true) {
                var dt = response.data.dt
                if(dt != null && dt.length > 0) {
                  for(var i = 0; i < dt.length; i++) {
                    if(dt[i].setting_key == 'currency') {
                      // const cpiCurrency = dt[i].setting_value
                      if(config.cpiEnable == "1") {
                        var isOperator = [2].includes(this.$store.getters.accountType);
                        if(isOperator) this.cpiDetails();
                      }
                      this.$store.dispatch("user/setCurrencyCode", dt[i].setting_value);
                      break;
                    }
                  }
                }
              } else {
                if (!this.$helpers.handleFeedback(this.submission.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.submission.status), "error");
              }
            }
          } catch (error) {
            this.submission.success = false;
            this.submission.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.submission.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.submission.success = false;
          this.submission.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.submission.status), "error");
        }
      );
    },
    cpiDetails: function() {
      let url = config.cpiDetailsUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.submission.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.submission.status = response.data.statusdesc;
              if (this.submission.success == true) {
                var dt = response.data.dt
                if(dt != null && dt.length > 0) {
                  this.$store.dispatch("user/setCpiDetails", true);
                }
              } else {
                if (!this.$helpers.handleFeedback(this.submission.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.submission.status), "error");
              }
            }
          } catch (error) {
            this.submission.success = false;
            this.submission.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.submission.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.submission.success = false;
          this.submission.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.submission.status), "error");
        }
      );
    }
  }
};
</script>
